import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlowChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M29.1667 30H32.5V18.3333H21.6667V10.8333H18.3333V18.3333H7.5V30H10.8333V21.6667H18.3333V30H21.6667V21.6667H29.1667V30Z",
			fill: "#CFD8DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1666 5H25.8333V13.3333H14.1666V5Z",
			fill: "#3F51B5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.6667 26.6667H35V35H26.6667V26.6667ZM5 26.6667H13.3333V35H5V26.6667ZM15.8333 26.6667H24.1667V35H15.8333V26.6667Z",
			fill: "#00BCD4"
		})
	]
});
export default SvgFlowChart;
